module.exports = __webpack_public_path__ + "static/media/cross-devices-icon.40176864.svg";